const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		hint: [],
		children: {
			ZZ1: {
				name: ['薪資', 'Payroll', '薪资'],
				children: {
					ZZ_HUIMIN_SALARY_ITEM_MAPPING: {
						name: ['(客製)薪資科目對應設定', '(Customize)Salary Item Mapping', '(客制)薪资科目对应设定'],
						url: '/zz_huimin_salary_item_mapping',
						hint: [],
					},
				},
			},
		},
	},
};

module.exports = (paidMenu) => {
	return { ...paidMenu, ...custMenu };
};
